import React from 'react';
import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin } from 'lucide-react';
import BrandLogo from './BrandLogo';
import { COMPANY, NAV_LINKS } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="bg-white inline-block p-4 rounded-md">
            <BrandLogo />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Refrigerated transport in Perth and Western Australia. Same-day,
            emergency, and scheduled cold-chain delivery — available around the
            clock. WAHVA accredited.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="p-2 rounded-md bg-white/5 hover:bg-white/10 transition">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 rounded-md bg-white/5 hover:bg-white/10 transition">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="p-2 rounded-md bg-white/5 hover:bg-white/10 transition">
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-white">Company</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="hover:text-white transition">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white">Services</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="#services" className="hover:text-white">Refrigerated Transport Perth</a></li>
            <li><a href="#services" className="hover:text-white">Same-Day Delivery</a></li>
            <li><a href="#services" className="hover:text-white">Emergency Transport</a></li>
            <li><a href="#services" className="hover:text-white">Scheduled Delivery</a></li>
            <li><a href="#services" className="hover:text-white">Last-Mile Cold Delivery</a></li>
            <li><a href="#about" className="hover:text-white">Cold Storage Solutions</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white">Get In Touch</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-2"><MapPin className="w-4 h-4 shrink-0 mt-0.5" /> {COMPANY.address}</li>
            <li>
              <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-white flex items-center gap-2">
                <Phone className="w-4 h-4" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white flex items-center gap-2 break-all">
                <Mail className="w-4 h-4 shrink-0" /> {COMPANY.email}
              </a>
            </li>
            <li className="text-slate-400">Open 24 Hours</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Singh Logistics WA. All rights reserved.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
